import { Users } from "lucide-react"
import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"

/**
 * OKS-527 — §14 holder-count chip ("👥 N have this").
 *
 * The count is a crew-internal aggregate (crewmates in THIS brand who hold
 * the badge) — count only, never identities (brand-isolation P0). A count
 * of 0 renders the "Be the first" tone (UX Spec §3 edge). The Lucide glyph
 * is decorative (`aria-hidden`); the text carries the meaning.
 */
export function BadgeHolderCount({
  count,
  className,
}: {
  count: number
  className?: string
}) {
  const { t } = useTranslation()

  const label =
    count > 0
      ? t("badges.creator.holder_count", { count })
      : t("badges.creator.be_first")

  return (
    <span
      data-testid="badge-holder-count"
      data-count={count}
      className={cn(
        "text-muted-foreground inline-flex items-center gap-1 text-xs",
        className,
      )}
    >
      <Users className="size-3 shrink-0" aria-hidden="true" />
      <span className="truncate">{label}</span>
    </span>
  )
}
